module.exports = __webpack_public_path__ + "static/media/rate_filter.53d125ff.svg";